import { render, staticRenderFns } from "./PreQuestion1.vue?vue&type=template&id=d88a1a66&scoped=true&"
import script from "./PreQuestion1.vue?vue&type=script&lang=js&"
export * from "./PreQuestion1.vue?vue&type=script&lang=js&"
import style0 from "./PreQuestion1.vue?vue&type=style&index=0&id=d88a1a66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88a1a66",
  null
  
)

export default component.exports